import type { GetTweetById200BasicInfoAllOf } from './getTweetById200BasicInfoAllOf';
import type { GetTweetById200BasicInfoAllOfTwo } from './getTweetById200BasicInfoAllOfTwo';

export type GetTweetById200BasicInfo = GetTweetById200BasicInfoAllOf & GetTweetById200BasicInfoAllOfTwo;
